import { Component, OnInit, Input, OnDestroy, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import * as Highcharts from 'highcharts/highstock';
import * as hc3d from "highcharts/highcharts-3d";
import { ChartService } from '../services/chart.service';
import { ChartObject } from '../objects/ChartObject';
import { Globals } from '../objects/Globals';
import { ThemeSettingService } from '../services/theme-setting.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { MainLoadingService } from '../services/main-loading.service';
import { ModalControlComponent } from '../modal-control/modal-control.component';
import { WorkspaceService } from '../services/workspace.service';
import { ContextMenuService, ContextMenuComponent } from 'ngx-contextmenu';
import HC_data from 'highcharts/modules/data';
import HC_accessibility from 'highcharts/modules/accessibility';
import { SummaryService } from '../services/summary.service';
import { EnvService } from '../env.service';
HC_data(Highcharts);
HC_accessibility(Highcharts);

hc3d(Highcharts);

Highcharts.setOptions({
  lang: {
    thousandsSep: ","
  }
});

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.css']
})
export class ChartComponent implements OnInit {

  @ViewChild(ContextMenuComponent) public basicMenu: ContextMenuComponent;
  
  private componentId:string;
  chartObject:ChartObject;
  backupChartObject: ChartObject;
  isBusy:boolean = false;
  loaderConfig:any;
  private previousComponentId: string;

  Highcharts = Highcharts; // required
  chartConstructor = 'chart'; // optional string, defaults to 'chart'
  updateFlag = false; // optional boolean
  oneToOneFlag = true; // optional boolean, defaults to false
  currentChart : number;
  totalCharts : number;
  modalRef: BsModalRef;
  loadingRef:BsModalRef;
  showExpand: boolean = false;
  @Input() isExpandChart:boolean = false;
  @Input() filledSpace: number = 0;
  @Input() chartName:string;
  @Input() set setComponentId(id:string){
    this.componentId = id;
    if (this.componentId){
      this.refreshChartCard();
    }
  }

  @Input() set setChartObject(chart: any){
    this.isBusy = false;
    if (chart){
      this.chartObject = {
        chartOptions: {},
        currentChart: 1,
        totalCharts: 1
      };
      this.chartObject.chartOptions = JSON.parse(chart);
      // this.chartObject.chartOptions["navigator"] = {};
      // this.chartObject.chartOptions["navigator"]["enabled"] = true;
      // this.chartObject.chartOptions["chart"]["style"]["fontFamily"] = "Lato, sans-serif, Arial, Helvetica";
    }
  }

  @Input() set setChartLoading(isLoading: boolean){
    this.isBusy = isLoading;
  }

  constructor(private elementRef: ElementRef, private globals:Globals, private chartService:ChartService, private themeSettingService: ThemeSettingService, private modalService: BsModalService, 
    private mainLoadingService: MainLoadingService, private workspaceService: WorkspaceService, 
    private contextMenuService: ContextMenuService, private summaryService: SummaryService,
    private env: EnvService) {
      this.showExpand = this.env.chartExpand;
      this.chartService.chartRefreshChanged$.subscribe(result => {
        if (result){
          // console.log(result);
          // var temp = this.chartObject
          // this.isBusy = true;
          // this.chartObject = null;
          // setTimeout(() => {
          //   this.chartObject = JSON.parse(JSON.stringify(temp));
          //   this.isBusy = false
          //   // Object.assign({}, temp);
          // },)
        }
      })

      this.summaryService.summaryUpdateChanged$.subscribe(result => {
        if (result){
          setTimeout(() => {
            this.playSound();
            this.updateFlag = true;
          }, 1000)
          
        }
      })
     }

  hasPrevious():boolean{
    return (this.chartObject != null && this.currentChart != 1);
  }

  hasNext():boolean{
    return (this.chartObject != null && this.currentChart != this.totalCharts);
  }
  nextChart(event){
    this.isBusy = true;
    this.backupChartObject = this.chartObject;
    this.chartObject = null;
    this.chartService.nextChart(this.componentId).subscribe(result=>{
      if(result == "1"){
        this.refreshChartCard();
      }
    });
  }

  previousChart(event){
    this.isBusy = true;
    this.backupChartObject = this.chartObject;
    this.chartObject = null; // to avoid error merging the object
    this.chartService.previousChart(this.componentId).subscribe(result=>{
      if(result == "1"){
        this.refreshChartCard();
      }
    });
  }

  refreshChartCard(){
    this.isBusy = true;
    this.chartService.getChart(this.componentId).subscribe(chart=>{
      var chartObject:ChartObject = JSON.parse(chart);
      this.previousComponentId = this.componentId;
      this.chartObject = chartObject;
      if (this.chartObject.chartOptions){
        if (this.chartObject.chartOptions["series"][0]["type"] == "area"){
          this.chartObject.chartOptions["plotOptions"]["area"]["point"]["events"]["click"] = this.GetChartData.bind(this);
        }
        else {
          this.chartObject.chartOptions["plotOptions"]["series"]["point"]["events"]["click"] = this.GetChartData.bind(this);
        }

        this.chartObject.chartOptions["yAxis"]["labels"] = {};
        this.chartObject.chartOptions["yAxis"]["labels"]["formatter"] = this.formatLabel.bind(this);
      }
      this.totalCharts = this.chartObject.totalCharts;
      this.currentChart = this.chartObject.currentChart;
      // this.chartObject.chartOptions["chart"]["width"] = null;["chart"]["width"] = null;
      // this.chartObject.chartOptions["chart"]["height"] = null; //percentage off the width
      // this.chartObject.chartOptions["chart"]["marginLeft"] = "150";
      // this.chartObject.chartOptions["chart"]["marginRight"] = "100";
      this.isBusy = false;
    }, error => {
      this.isBusy = false;
      this.chartObject = this.backupChartObject;
    });
  }

  ngOnInit() {
    this.loaderConfig = this.themeSettingService.getTheme();
    // setTimeout(() => {
    //   if (!this.componentId) this.isBusy = false;
    // }, 5000)
  }

  public onContextMenu($event, item: any): void {
    if($event.button == 0){
      this.contextMenuService.show.next({
        contextMenu: this.basicMenu,
        event: $event,
        item: item,
      });
    }
    $event.preventDefault();
    $event.stopPropagation();
  }
  
  GetChartData(e){
    const p = e.point;
    this.mainLoadingService.setLoading(true);
    
    var category = encodeURIComponent(p.category);
    if (p.series.userOptions.type == "pie") {
      category = encodeURIComponent(p.name);
    }
    else if (p.series.userOptions.type == "area"){
      category = p.series.name;
    }

    this.chartService.getChartData(this.componentId, p.series.name, category).subscribe(result=> {
      this.mainLoadingService.setLoading(false);
      if (result){
        this.openSummaryPopup(result);
      }
    }, error => {
      this.mainLoadingService.setLoading(false);
    });
  }

  formatLabel(e){
    
      if(e.value >= 1000000000){
          return (e.value / 1000000000) + 'B';
      }
      else if(e.value >= 1000000) {
          return (e.value / 1000000) + 'M';
      }
      else if(e.value >= 1000) {
          return (e.value / 1000) + 'K';
      }
      else {
          return e.value;
      }
  }

  openSummaryPopup(id:string){

    const config: ModalOptions = {
      keyboard: false,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered modal-control',
      initialState: {
        componentId: id,
        title: "Report View",
        popupTitle: "Report View",
        type: "summary"
      }
    };

    if (this.modalService.getModalsCount() > 0){
      document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.remove('show');
    }

    this.modalService.onHide.subscribe((reason: string) => {
      if (this.modalService.getModalsCount() > 0){
        document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.add('show');
      }
    })

    this.modalRef = this.modalService.show(ModalControlComponent, config);
  }

  showAll(){
    //show whole data
    this.mainLoadingService.setLoading(true);
    this.chartService.getFullChartData(this.componentId).subscribe(result => {
      this.mainLoadingService.setLoading(false);
      if (result){
        this.openSummaryPopup(result);
      }
    }, error => {
      this.mainLoadingService.setLoading(false);
    })
  }

  expandChart(){
    
    this.chartService.expandChart(this.componentId).subscribe(result => {
      const config: ModalOptions = {
        keyboard: false,
        ignoreBackdropClick: true,
        class: 'modal-dialog-centered modal-control',
        initialState: {
          componentId: result,
          title: "Report View",
          popupTitle: "",
          type: "chart"
        }
      };

      if (this.modalService.getModalsCount() > 0){
        document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.remove('show');
      }
  
      this.modalService.onHide.subscribe((reason: string) => {
        if (this.modalService.getModalsCount() > 0){
          document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.add('show');
        }
      })
  
      this.modalRef = this.modalService.show(ModalControlComponent, config);
    })
  }

  playSound(){
    var audio = new Audio("assets/sound/inflicted.mp3");
    audio.muted = false;
    audio.play();
  }
}
